module.exports = __webpack_public_path__ + "assets/img/GS.0e3aef40.png";